var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLoadingBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8883 4.61491C29.5596 2.92052 28.732 0.976135 26.9563 0.565545C23.5552 -0.220902 19.9992 -0.190183 16.5851 0.676805C12.0995 1.8159 8.08731 4.34057 5.11943 7.89163C2.15154 11.4427 0.379098 15.8392 0.0542598 20.4558C-0.270579 25.0724 0.868734 29.6738 3.31011 33.6055C5.75148 37.5372 9.37056 40.5988 13.6525 42.3548C17.9344 44.1108 22.661 44.4718 27.1599 43.3863C31.6588 42.3009 35.7008 39.8243 38.7109 36.3089C41.0019 33.6333 42.6063 30.4597 43.4096 27.0625C43.829 25.2888 42.4533 23.6848 40.6369 23.5352C38.8205 23.3856 37.2606 24.7562 36.7281 26.4992C36.112 28.5161 35.0845 30.3965 33.6976 32.0163C31.5906 34.477 28.7612 36.2106 25.6119 36.9704C22.4627 37.7303 19.1541 37.4776 16.1567 36.2484C13.1594 35.0192 10.626 32.876 8.91708 30.1239C7.20811 27.3717 6.4106 24.1507 6.63798 20.9191C6.86537 17.6875 8.10608 14.6099 10.1836 12.1241C12.2611 9.6384 15.0696 7.87113 18.2096 7.07376C20.2763 6.54892 22.4174 6.46188 24.4984 6.804C26.2968 7.09966 28.2169 6.30929 28.8883 4.61491Z",
    fill: "#2AAAE2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 8,
    r: 3,
    fill: "#13619E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLoadingBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-loading-blue.3122567268de3de01cc86f251910f23f.svg";